import React from 'react';
import TextField from '@mui/material/TextField';

function CustomizedTextField({
    fullWidth = false,
    required = false,
    placeholder,
    error,
    width,
    label,
    value,
    name,
    className,
    onChange
}) {
    return (
        <TextField
            name={name}
            error={error?.length ? true : false}
            data-testid="text-field"
            fullWidth={fullWidth}
            placeholder={placeholder}
            helperText={error}
            required={required}
            value={value}
            label={label}
            variant="outlined"
            className={className}
            sx={{
                width: width ? `${width}px` : 'auto',
                height: {
                    xs: '32px',
                    sm: '50px'
                },
                backgroundColor: '#224957',
                borderRadius: '10px !important',
                border: 'none',
                fontFamily: 'LexendDeca',
                letterSpacing: '0.8px',
                '& .MuiFormLabel-root': {
                    color: '#fff !important',
                    fontSize: {
                        xs: '8px',
                        sm: '14px'
                    },
                    lineHeight: '16px',
                    letterSpacing: '0.8px',
                    top: {
                        xs: '-8px',
                        md: '0'
                    }
                },
                '& .MuiOutlinedInput-root': {
                    height: {
                        xs: '32px',
                        sm: '50px'
                    },
                    borderRadius: '10px !important',
                    fontSize: {
                        xs: '8px',
                        sm: '14px'
                    }
                },
                '& .Mui-focused': {
                    color: '#fff !important',
                    top: {
                        xs: '0'
                    }
                    // padding: '4px 12px',
                },
                '& .MuiInputLabel-shrink': {
                    color: '#fff !important',
                    backgroundColor: '#224957',
                    padding: { xs: '4px 6px', sm: '8px 12px' },
                    borderRadius: '10px',
                    fontSize: {
                        xs: '8px',
                        sm: '14px'
                    },
                    letterSpacing: '0.8px'
                },
                '& .MuiInputBase-input': {
                    color: '#fff'
                },
                '& .MuiOutlinedInput-notchedOutline': {
                    border: 'none',
                    color: '#fff'
                }
            }}
            onChange={onChange}
        />
    );
}

export default CustomizedTextField;
